import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { ZoneStatus, useUpdateZoneStatusMutation } from '@/__generated__/graphql';
import { getNextZoneStatus } from '../common';

type Props = {
  zoneId: string;
  zoneStatus: ZoneStatus;
};

export const MenuButton = ({ zoneId, zoneStatus }: Props) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorElement);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };

  const [mutate, { loading }] = useUpdateZoneStatusMutation({
    refetchQueries: ['zoneAndHistoriesForZoneManagement'],
  });

  const nextZoneStatus = getNextZoneStatus(zoneStatus);

  if (!nextZoneStatus) {
    return <></>;
  }

  const assignToMe = () => {
    mutate({
      variables: {
        input: {
          zoneId,
          status: nextZoneStatus,
        },
      },
    }).then(handleClose);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorElement} open={open} onClose={handleClose}>
        <MenuItem disabled={loading} onClick={assignToMe}>
          Assign to me
          {loading && <CircularProgress size={20} />}
        </MenuItem>
      </Menu>
    </div>
  );
};
